import { render, staticRenderFns } from "./report.vue?vue&type=template&id=31838aa2&scoped=true&"
import script from "./report.vue?vue&type=script&lang=js&"
export * from "./report.vue?vue&type=script&lang=js&"
import style0 from "./report.vue?vue&type=style&index=0&id=31838aa2&lang=scss&scoped=true&"
import style1 from "./report.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31838aa2",
  null
  
)

export default component.exports